import { ReduxStore } from 'Redux';
import { login } from 'Redux/auth/authThunks';
import { loadingAction } from 'Redux/userInterface/userInterfaceActions';
import { LOADING } from 'Redux/userInterface/userInterfaceConstants';
import { PaymentsService } from 'Services/ServiceFactory';
import { captureSentry } from 'Utils/sentry';
import Routes from '../../routes/profileRoutes';
import { setPayments } from './paymentActions';

export const getPayments = () => {
  return async dispatch => {
    try {
      dispatch(loadingAction(LOADING.PAYMENTS_GET, true));

      const { loggedIn } = ReduxStore.getState().auth;

      if (!loggedIn) {
        await dispatch(login());
      }

      const { userId } = ReduxStore.getState().profile;
      const paymentResp = await PaymentsService.getPayments(userId);
      if (!paymentResp) {
        throw Error('No response from getPayments');
      }
      await dispatch(setPayments(paymentResp));
    } catch (e) {
      captureSentry(e, {
        extra: { profileType: ReduxStore.getState().profile.profileType }
      });
      window.location = Routes.ERROR;
    } finally {
      dispatch(loadingAction(LOADING.PAYMENTS_GET, false));
    }
  };
};
